import { render, staticRenderFns } from "./PlaceHeader.vue?vue&type=template&id=1095c6a4&scoped=true&"
import script from "./PlaceHeader.vue?vue&type=script&lang=ts&"
export * from "./PlaceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceHeader.vue?vue&type=style&index=0&id=1095c6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095c6a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VList,VListItem,VListItemTitle,VMenu})
